<template>
  <div>
    <div>
      <b-row>
        <b-col>
          <div>
            <b-card no-body>
              <b-tabs card>
                <b-tab lazy title="Edit Location Group Devices">
                  <b-card>
                    <b-row
                      ><b-col
                        >Choose Location Group to edit
                        <b-form-select
                          v-model="selected"
                          :options="locationGroupList"
                          class="mb-3"
                        >
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row
                      ><b-col cols="12" class="text-center">{{
                        this.selected
                      }}</b-col></b-row
                    >
                    <b-card v-if="selected != ''">
                      <b-tabs fill>
                        <b-tab
                          title="C1 Devices"
                          :disabled="
                            !UserAccess.includes('CLA') &&
                              !UserProfile.includes('SYS') &&
                              !UserProfile.includes('SUP')
                          "
                          lazy
                        >
                          <b-table
                            sticky-header
                            id="C1Table"
                            :items="C1DeviceList"
                            :headers="fields"
                            no-border-collapse
                            hover
                            show-empty
                            empty-text="You currently dont have any Devices of this type"
                            responsive
                            small
                          >
                            <!-- getNewName -->
                            <template v-slot:cell(InLocationGroup)="{ item }">
                              <b-form-checkbox
                                :id="item.ID"
                                v-model="item.InLocationGroup"
                                name="checkbox-1"
                                value="TRUE"
                                unchecked-value="FALSE"
                              >
                              </b-form-checkbox>
                            </template>
                            <template v-slot:cell(ID)="{ item }">
                              {{ getNewName(item.ID, "C1") }}
                            </template>
                          </b-table>
                        </b-tab>
                        <b-tab
                          title="O1 Devices"
                          :disabled="
                            !UserAccess.includes('CLA') &&
                              !UserProfile.includes('SYS') &&
                              !UserProfile.includes('SUP')
                          "
                        >
                          <b-table
                            sticky-header
                            id="O1Table"
                            :items="O1DeviceList"
                            :headers="fields"
                            no-border-collapse
                            hover
                            show-empty
                            empty-text="You currently dont have any Devices of this type"
                            responsive
                            small
                          >
                            <template v-slot:cell(InLocationGroup)="{ item }">
                              <b-form-checkbox
                                :id="item.ID"
                                v-model="item.InLocationGroup"
                                name="checkbox-1"
                                value="TRUE"
                                unchecked-value="FALSE"
                              >
                              </b-form-checkbox>
                            </template>
                            <template v-slot:cell(ID)="{ item }">
                              {{ getNewName(item.ID, "O1") }}
                            </template>
                          </b-table>
                        </b-tab>
                        <b-tab title = "Routers"
                        :disabled="
                            !UserAccess.includes('CLA') &&
                              !UserProfile.includes('SYS') &&
                              !UserProfile.includes('SUP')
                          ">
                          
                       <b-table
                            sticky-header
                            id="RouterTable"
                            :items="RouterList"
                            :headers="fields"
                            no-border-collapse
                            hover
                            show-empty
                            empty-text="You currently dont have any routers to show"
                            responsive
                            small
                          >
                            <template v-slot:cell(InLocationGroup)="{ item }">
                              <b-form-checkbox
                                :id="item.ID"
                                v-model="item.InLocationGroup"
                                name="checkbox-1"
                                value="TRUE"
                                unchecked-value="FALSE"
                              >
                              </b-form-checkbox>
                            </template>
                          </b-table>
                        </b-tab>
                        <!-- <b-tab
                          title="Handwash Units"
                          :disabled="
                            !UserAccess.includes('WBU') &&
                              !UserProfile.includes('SYS') &&
                              !UserProfile.includes('SUP')
                          "
                        >
                          <b-table
                            sticky-header
                            id="HW1Table"
                            :items="HandwashList"
                            :headers="fields"
                            no-border-collapse
                            hover
                            show-empty
                            empty-text="You currently dont have any Devices of this type"
                            responsive
                            small
                          >
                            <template v-slot:cell(InLocationGroup)="{ item }">
                              <b-form-checkbox
                                :id="item.ID"
                                v-model="item.InLocationGroup"
                                name="checkbox-1"
                                value="TRUE"
                                unchecked-value="FALSE"
                              >
                              </b-form-checkbox>
                            </template>
                          </b-table>
                        </b-tab> -->
                        <b-tab title="Outlets">
                          <b-table
                            sticky-header
                            id="OutletTable"
                            :items="OutletList"
                            :headers="fields"
                            no-border-collapse
                            hover
                            show-empty
                            empty-text="You currently dont have any outlets to show"
                            responsive
                            small
                          >
                            <template v-slot:cell(InLocationGroup)="{ item }">
                              <b-form-checkbox
                                :id="item.ID"
                                v-model="item.InLocationGroup"
                                name="checkbox-1"
                                value="TRUE"
                                unchecked-value="FALSE"
                              >
                              </b-form-checkbox>
                            </template>
                          </b-table>
                        </b-tab>
                      </b-tabs>
                      <b-row
                        ><b-col><br /></b-col
                      ></b-row>
                      <b-row>
                        <b-col cols="6" class="text-center"
                          ><b-button
                            v-on:click="submitLocationGroupDevices()"
                            variant="info"
                            >Save</b-button
                          ></b-col
                        >
                        <b-col cols="6" class="text-center"
                          ><b-button v-on:click="cancelManagement()"
                            >Cancel</b-button
                          ></b-col
                        >
                      </b-row>
                    </b-card>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { IDToHuman } from "../CustomFunctions/HumanName.js";

export default {
  computed: {},
  components: {
  },

  data() {
    return {
      DeviceIDToChange: { C1: [], O1: [] },

      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
      UserAccess: localStorage.getItem("accessGroup"),
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("profileportal"),
      level1modalcheck: "",
      level2modalcheck: "",
      level3modalcheck: "",
      level1newFilterName: "",
      level2newFilterName: "",
      level3newFilterName: "",
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      fields: [],
      subgroupoptions: [],
      level1options: [],
      level2options: [],
      level3options: [],
      selectedlocation: localStorage.getItem("CurrentLocation"),
      level3selected: "",
      level2selected: "",
      level1selected: "",
      SubgroupName: "",
      subgroupNames: [],
      subgroupeditselectedNewName: "",
      SubgroupLvl1Names: [],
      SubgroupLvl2Names: [],
      SubgroupLvl3Names: [],
      level3deletemodalcheck: "",
      level3removal: "",
      level3editcheck: "",
      level3editselected: "",
      level2deletemodalcheck: "",
      level2removal: "",
      level2editcheck: "",
      level2editselected: "",
      level1deletemodalcheck: "",
      level1removal: "",
      level1editcheck: "",
      level1editselected: "",
      subgroupdeletemodalcheck: "",
      subgroupremoval: "",
      subgroupeditcheck: "",
      subgroupeditselected: "",
      selected: "",
      level1NewName: "",
      level2NewName: "",
      level3NewName: "",
      level1deletemodalReason: "",
      level2deletemodalReason: "",
      level3deletemodalReason: "",
      EditSubgroupData: "",
      DeleteSubgroupData: "",
      locationGroupRemovalReason: "",
      DeleteSubgroupType: "",
      userName: localStorage.getItem("fullname"),
      currentLocation: localStorage.getItem("CurrentLocation"),
      C1DeviceList: [],
      O1DeviceList: [],
      RouterList: [],
      HandwashList: [],
      OutletList: [],
      locationGroupList: [],
      devicefields: [
        { key: "Type", variant: "primary" },
        { key: "Device ID" },
        { key: "LocationGroup" },
      ],
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LocationSubgroup",
      LocationDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.subgroupoptions = [];
        let MainSubgroup = response.data.Values;

        for (let i = 0; i < MainSubgroup.length; i++) {
          let Level1Var = "--";
          let Level2Var = "--";
          let Level3Var = "--";
          if (MainSubgroup[i][1] != null) {
            Level1Var = MainSubgroup[i][1];
          }
          if (MainSubgroup[i][2] != null) {
            Level2Var = MainSubgroup[i][2];
          }
          if (MainSubgroup[i][3] != null) {
            Level3Var = MainSubgroup[i][3];
          }
          this.subgroupNames.push({
            Name: MainSubgroup[i][0],
            Level_1: Level1Var,
            Level_2: Level2Var,
            Level_3: Level3Var,
            Edit: "",
            Delete: "",
          });
          this.subgroupoptions.push({
            value: MainSubgroup[i][0],
            text: MainSubgroup[i][0],
          });
        }
      });

    let LookUpUrl3 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders3 = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LocationSubgroupList",
      LocationDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrl3, this.LookUpRequest, LookUpHeaders3)
      .then((response) => {
        let subgroupArray = response.data.Values[0];
        for (let i = 0; i < subgroupArray.length; i++) {
          this.locationGroupList.push({
            value: subgroupArray[i],
            text: subgroupArray[i],
          });
        }
      });

    let LookUpUrl1 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders1 = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LocationSubgroupList",
      LocationDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrl1, this.LookUpRequest, LookUpHeaders1)
      .then((response) => {
        let SubGroupLvl1 = response.data.Values[1];
        let SubGroupLvl2 = response.data.Values[2];
        let SubGroupLvl3 = response.data.Values[3];

        for (let i = 0; i < SubGroupLvl1.length; i++) {
          this.SubgroupLvl1Names.push({
            Name: SubGroupLvl1[i],
            Edit: "",
            Delete: "",
          });
          this.level1options.push({
            value: SubGroupLvl1[i],
            text: SubGroupLvl1[i],
          });
        }
        for (let i = 0; i < SubGroupLvl2.length; i++) {
          this.SubgroupLvl2Names.push({
            Name: SubGroupLvl2[i],
            Edit: "",
            Delete: "",
          });
          this.level2options.push({
            value: SubGroupLvl2[i],
            text: SubGroupLvl2[i],
          });
        }
        for (let i = 0; i < SubGroupLvl3.length; i++) {
          this.SubgroupLvl3Names.push({
            Name: SubGroupLvl3[i],
            Edit: "",
            Delete: "",
          });
          this.level3options.push({
            value: SubGroupLvl3[i],
            text: SubGroupLvl3[i],
          });
        }
      });
  },

  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      let ClarenceType = Type;

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data;
    },

    async IDGetArrays(ID, Type) {
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },

    deviceLookup() {},

    submitLocationGroupDevices() {
      let LookUpUrl3 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders3 = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "ModifySubgroupDevice",
        LocationDict: [
          {
            SubGroupName: this.selected,
            C1Devices: this.C1DeviceList,
            O1Devices: this.O1DeviceList,
            Washbasins: this.HandwashList,
            Outlets: this.OutletList,
            Routers: this.RouterList
          },
        ],
      };

      axios
        .post(LookUpUrl3, this.LookUpRequest, LookUpHeaders3)
        .then((response) => {
          console.log("update Posted")
          console.log(response)
          response;
          alert("Location Group Devices have been updated");
          this.cancelManagement();
        });
    },

    cancelManagement() {
      this.selected = "";
    },

    selectNewDevices() {
      let LookUpUrl3 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders3 = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "SubgroupDevices",
        LocationDict: [
          {
            Location: this.selectedlocation,
            SubGroupName: this.selected,
          },
        ],
      };

      axios
        .post(LookUpUrl3, this.LookUpRequest, LookUpHeaders3)
        .then((response) => {
          this.C1DeviceList = [];
          this.O1DeviceList = [];
          this.HandwashList = [];
          this.OutletList = [];
          this.RouterList = [];

          let C1DeviceArray = response.data.Values[0];
          for (let i = 0; i < C1DeviceArray.length; i++) {
            this.IDGetArrays(C1DeviceArray[i][0], "C1");
            this.C1DeviceList.push({
              ID: C1DeviceArray[i][0],
              RoomArea: C1DeviceArray[i][2],
              InLocationGroup: C1DeviceArray[i][1],
            });
          }
          let O1DeviceArray = response.data.Values[1];
          for (let i = 0; i < O1DeviceArray.length; i++) {
            this.IDGetArrays(O1DeviceArray[i][0], "O1");
            this.O1DeviceList.push({
              ID: O1DeviceArray[i][0],
              RoomArea: O1DeviceArray[i][2],
              InLocationGroup: O1DeviceArray[i][1],
            });
          }
          let RouterArray = response.data.Values[2];
          for (let i=0;i<RouterArray.length;i++){
            this.RouterList.push({
              ID: RouterArray[i][0],
              RoomArea: RouterArray[i][2],
              InLocationGroup: RouterArray[i][1]
            });
          }
          let HWDeviceArray = response.data.Values[3];
          for (let i = 0; i < HWDeviceArray.length; i++) {
            this.HandwashList.push({
              ID: HWDeviceArray[i][0],
              RoomArea: HWDeviceArray[i][2],
              InLocationGroup: HWDeviceArray[i][1],
            });
          }
          let OutletArray = response.data.Values[4];
          for (let i = 0; i < OutletArray.length; i++) {
            this.OutletList.push({
              ID: OutletArray[i][0],
              RoomArea: OutletArray[i][2],
              InLocationGroup: OutletArray[i][1],
            });
          }
          this.SwitchToHuman("C1");
          this.SwitchToHuman("O1");
        });
    },
  },
  watch: {
    selected() {
      this.selectNewDevices();
    },
  },
};
</script>

<style>
#Table {
  margin: auto;
  text-align: center;
}

.modal {
  text-align: center;
}
</style>
